export const UNREAD = 'unread';
export const READ = 'read';
export const UNANSWERED = 'unanswered';
export const ANSWERED = 'answered';
